import React from 'react';

import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';

import type { NavigationButtonProperties } from './NavigationButton.types';

export const NavigationButton: React.FC<NavigationButtonProperties> = ({
  dataTest = 'navigation_button',
  onClick,
  to,
  search,
  color,
  label,
  variant = 'contained',
  size = 'large',
  sx,
  startIcon,
  endIcon,
}) => {
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const linkProperties: any = {
    to,
    ...(search && { search }),
  };

  return (
    <Button
      data-testid={dataTest}
      color={color}
      variant={variant}
      size={size}
      onClick={handleClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={sx}
      component={Link}
      {...linkProperties}
    >
      {label}
    </Button>
  );
};
